var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"networkingSidebarWidget",staticClass:"networking-widget__sidebar",attrs:{"id":"networking-widget__sidebar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }